(function($) {
  'use strict';

  const gallery = {
    tabs: function() {
      const tabs = new tabbytabtab($('[data-js-hook="gallery-tabs"]'));

      tabs.onTab(function($this){
        let $category = $('[data-gallery="' + $this.data('toggle-gallery') + '"]');

        if ($category.length) {
          $('[data-gallery]').hide();

          $category.show().find('[data-manual-src]').each(function(){
            if (!$(this).hasClass('loaded')) {
              if ($(this).get(0).tagName == 'IMG') {
                $(this)
                  .attr('src', $(this).data('manual-src'))
                  .removeAttr('data-manual-src')
                  .load(function(){
                    $(this).addClass('loaded');
                  })
              } else {
                $(this)
                  .css('background-image', 'url(' + $(this).data('manual-src') + ')')
                  .removeAttr('data-manual-src')
                  .addClass('loaded');
              }
            }
          });
        }
      });
    },

    analytics: function() {
      $('[data-gallery-link]').click(function(){
        Jonahlytics.event.galleryImage($(this).attr('href'));
      });
    },

    ready: function() {
      this.tabs();
      this.analytics();
    }
  };

  $(function(){
    gallery.ready();
  });

})(jQuery);
